import * as React from "react";

function Edit(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M2 16h1.414l9.314-9.314-1.414-1.414L2 14.586V16zm16 2H0v-4.243L13.435.322a1 1 0 011.414 0l2.829 2.829a1 1 0 010 1.414L6.243 16H18v2zM12.728 3.858l1.414 1.414 1.414-1.414-1.414-1.414-1.414 1.414z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoEdit = React.memo(Edit);
export default MemoEdit;
